import { render, staticRenderFns } from "./DropdownUser.vue?vue&type=template&id=1018e65b"
import script from "./DropdownUser.vue?vue&type=script&lang=js"
export * from "./DropdownUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports